import { create } from 'zustand';
import { isValidAdminAccessToken, normalizeAdminSession } from '@/services/auth-token';

const LEGACY_STORAGE_KEY = 'convoy-admin-session';
const STORAGE_KEY = 'convoy-admin-session-v2';
sessionStorage.removeItem(LEGACY_STORAGE_KEY);

function readInitialSession() {
  try {
    const parsed = JSON.parse(sessionStorage.getItem(STORAGE_KEY) ?? '{}');
    const normalized = normalizeAdminSession(parsed);
    if (!isValidAdminAccessToken(normalized.accessToken, 0)) {
      sessionStorage.removeItem(STORAGE_KEY);
      return {};
    }
    return normalized;
  } catch {
    sessionStorage.removeItem(STORAGE_KEY);
    return {};
  }
}

const initial = readInitialSession();
export const useAuthStore = create((set) => ({
  accessToken: initial.accessToken ?? null,
  admin: initial.admin ?? null,
  sessionId: initial.sessionId ?? null,
  expiresInSeconds: initial.expiresInSeconds ?? 0,
  expiresAt: initial.expiresAt ?? 0,
  setSession: (input) => {
    const session = normalizeAdminSession(input);
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(session));
    set(session);
    return session;
  },
  clear: () => {
    sessionStorage.removeItem(STORAGE_KEY);
    set({ accessToken: null, admin: null, sessionId: null, expiresInSeconds: 0, expiresAt: 0 });
  },
}));
